<template lang="pug">
.detail-upgrades(v-if="display")
  p.detail-label Additional Options
    app-tooltip(
      v-for="tooltip in tooltips",
      v-if="tooltip.Type == 'Options' && tooltip.Visible",
      :key="tooltip.Type",
      :tip_open="tip_open",
      :text="tooltip.Text",
      @tooltipToggle="tooltipToggle")
  .detail-upgrade(
    v-for="item in data",
    :disabled="disabled",
    :key="item.ID",
    :class="{ 'is-selected': upgrade == item.ID }")
    span.detail-upgradeText(
      tabindex="0",
      @click="set_upgrade({ slug: item.UrlSlug })",
      @keypress.enter="set_upgrade({ slug: item.UrlSlug })",
      :style="styles.primary.color",
      :data-text="item.Text") {{ item.Text }}
</template>


<script>
import Theme from "@/listing-app/mixins/Theme";
import TooltipControl from "@/listing-app/mixins/TooltipControl";

import Tooltip from "@/listing-app/components/detail/Tooltip";
export default {
  name: "Upgrades",
  mixins: [Theme, TooltipControl],
  props: ["data", "tooltips", "upgrade", "disabled"],
  components: {
    appTooltip: Tooltip,
  },
  data() {
    return {};
  },
  computed: {
    display() {
      let display = true;

      if (this.data == null || this.data.length === 0) {
        display = false;
      }
      if (this.data.length == 1 && this.data[0].Text.trim() == "") {
        display = false;
      }
      return display;
    },
  },
  methods: {
    set_upgrade(payload) {
			if (!this.disabled) {
				this.$emit("setUpgrade", payload);
			}
    },
  },
};
</script>


<style lang="scss" scoped>
.detail-upgrades {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  position: relative;
  .detail-label {
    flex: 0 1 auto;
  }
}

.detail-upgrade {
  display: flex;
  margin-bottom: 4px;
  align-items: flex-start;
  z-index: 1;

  &.is-selected .detail-upgradeText:before {
    background: currentColor;
    box-shadow: inset 0 0 0 4px $white;
  }

  &[disabled][disabled] {
    pointer-events: none;
    .detail-upgradeText {
			pointer-events: none;
      &:before {
        pointer-events: none;
        background: $gray;
        box-shadow: inset 0 0 0 0 $white;
        border-color: $gray;
      }
    }
  }

  .detail-upgradeText {
    display: flex;
    align-items: center;
    line-height: 1;
    font-size: 0;
    cursor: pointer;
    &:before {
      content: "";
      height: 20px;
      width: 20px;
      margin-right: 10px;
      border: 1px solid currentColor;
      box-shadow: inset 0 0 0 0 $white;
      transition: 0.25s ease;
    }
    &:after {
      font-size: 18px;
      color: $black;
      content: attr(data-text);
    }
  }
}
</style>
